import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import PageLayout from "@/components/layout/PageLayout";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <PageLayout>
      <Helmet>
        <title>Seite nicht gefunden – NextInvoice</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <section className="flex min-h-[60vh] items-center justify-center bg-background">
        <div className="text-center">
          <h1 className="mb-4 font-display text-6xl font-bold text-foreground">404</h1>
          <p className="mb-6 text-xl text-muted-foreground">Diese Seite wurde nicht gefunden.</p>
          <Link
            to="/"
            className="inline-flex items-center rounded-xl bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90"
          >
            Zur Startseite
          </Link>
        </div>
      </section>
    </PageLayout>
  );
};

export default NotFound;
